import {Component, HostListener, OnInit} from '@angular/core';
import {VersionService} from "./_services/getVersion.service";
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {VersionFromBackendService} from "./_services/version-from-backend.service";
import {FileUploadService} from "./_services/file-upload.service";
import {AppBlockerService} from "./_services/app-blocker.service";
import {AsyncPipe} from "@angular/common";
import {NotificationComponent} from "./components/admin/components/notification/notification.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, AsyncPipe, NotificationComponent]
})
export class AppComponent implements OnInit{
  title = 'colorjob-ui';
  version = '';
  versionFromBack: string;
  isAuthPage = false;
  isWelcomePage = false;
  showBothVersions = false;


  constructor(private versionService: VersionService,
               private route: Router,
              private versionFromBackService: VersionFromBackendService,
              protected fileUploadService: FileUploadService,
              protected appBlocker: AppBlockerService) {
  }

  // Popups close on Escape too, so swallow it while files are being saved or the app is blocked
  @HostListener('document:keydown.escape', ['$event'])
  blockEscapeWhileUploading(event: KeyboardEvent) {
    if (this.fileUploadService.inProgress || this.appBlocker.active) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  ngOnInit(): void {
    this.getVersionFromBack()
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isWelcomePage = event.urlAfterRedirects.includes('welcome');
        this.isAuthPage =
          event.urlAfterRedirects.includes('login')
          || event.urlAfterRedirects.includes('forgot-password')
          || this.isWelcomePage;
      }
    });

  }

  getVersionFromBack() {
    this.versionFromBackService.getVersion().subscribe(data => {
      this.versionFromBack = data;
      this.getVersionFromFront()
    })
  }

  getVersionFromFront() {
    this.versionService.getVersion().subscribe(data => {
      this.version = data;
      if(this.version !== this.versionFromBack) {
        this.showBothVersions = true;
      }
    });
  }
}

